import { render, staticRenderFns } from "./TaxReturnRevenueSection.vue?vue&type=template&id=6b6ecd3a&scoped=true&"
import script from "./TaxReturnRevenueSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnRevenueSection.vue?vue&type=script&lang=js&"
import style0 from "./TaxReturnRevenueSection.vue?vue&type=style&index=0&id=6b6ecd3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ecd3a",
  null
  
)

export default component.exports